export default "__VITE_ASSET__DHDl1fJ1__"